'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = function (_React$Component) {
	(0, _inherits3.default)(Slider, _React$Component);

	function Slider() {
		(0, _classCallCheck3.default)(this, Slider);
		return (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
	}

	(0, _createClass3.default)(Slider, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    lineHeight = _props.lineHeight,
			    lineSpacing = _props.lineSpacing,
			    width = _props.width;


			var yOffset = lineSpacing + lineHeight;

			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerSlider' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '1314878248',
					css: '.BurgerSlider{display:inline-block;}.BurgerSlider .BurgerInner{top:' + lineHeight / 2 + 'px;}.BurgerSlider .BurgerInner:before{top:' + yOffset + 'px;-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-property:transform,opacity;transition-property:transform,opacity;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:0.15s;transition-duration:0.15s;}.BurgerSlider .BurgerInner:after{top:' + yOffset * 2 + 'px;}.BurgerSlider.BurgerActive .BurgerInner{-webkit-transform:translate3d(0,' + yOffset + 'px,0) rotate(45deg);-ms-transform:translate3d(0,' + yOffset + 'px,0) rotate(45deg);transform:translate3d(0,' + yOffset + 'px,0) rotate(45deg);}.BurgerSlider.BurgerActive .BurgerInner:before{-webkit-transform:rotate(-45deg) translate3d(' + width / -7 + 'px,' + lineSpacing * -1 + 'px,0);-ms-transform:rotate(-45deg) translate3d(' + width / -7 + 'px,' + lineSpacing * -1 + 'px,0);transform:rotate(-45deg) translate3d(' + width / -7 + 'px,' + lineSpacing * -1 + 'px,0);opacity:0;}.BurgerSlider.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-90deg);-ms-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-90deg);transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-90deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/slider.js */',
					dynamic: [lineHeight / 2, yOffset, yOffset * 2, yOffset, width / -7, lineSpacing * -1, yOffset * -2]
				})
			);
		}
	}]);
	return Slider;
}(_react2.default.Component);

exports.default = Slider;


Slider.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=slider.js.map